// extracted by mini-css-extract-plugin
export default {"container":"styles__container--b329ed6989b82fdba411"};